import type { FC} from 'react';
import { memo } from 'react';

// import { QrReader } from 'react-qr-reader';
import { ModalMiddle } from '@src/library/components/common';

import * as st from './styles.module.scss';

interface Props {
	close: () => void;
	handleScan: (data: string) => void;
}

export const QrModalScanner: FC<Props> = memo(({ close, handleScan }) => {
	return (
		<ModalMiddle isOpen={true} close={close} onRequestClose={close}>
			{/* <QrReader
				onResult={(result) => {
					if (!!result) {
						handleScan(result.getText());
					}
				}}
				constraints={{ facingMode: 'user' }}
				className={st.qr}
			/> */}
		</ModalMiddle>
	);
});
